import { createSlice } from '@reduxjs/toolkit';

import { SIDEBAR_CACHE_KEY } from 'shared/consts';
import { LocalStorage } from 'tools';

import { IAlert } from './models';

interface IUiSliceState {
  alert: IAlert | undefined;
  copyPopupShow: boolean;
  triggerCopying: boolean;
  isSidebarOpened: boolean;
  searchProjectText: string;
  searchArchiveProjectText: string;
  layoutWidth: number;
}

const lsSidebarState = LocalStorage.get<string>(SIDEBAR_CACHE_KEY);
const isSidebarOpened = lsSidebarState ? lsSidebarState === 'true' : true;

const uiSliceInitialState: IUiSliceState = {
  alert: undefined,
  copyPopupShow: false,
  triggerCopying: false,
  isSidebarOpened: isSidebarOpened,
  searchProjectText: '',
  searchArchiveProjectText: '',
  layoutWidth: 0,
};

const uiSlice = createSlice({
  name: 'ui',
  initialState: uiSliceInitialState as IUiSliceState,
  reducers: {
    setAlertState: (state, { payload }: { payload: IAlert }) => {
      state.alert = payload;
    },
    dropAlertState: state => {
      state.alert = undefined;
    },
    setCopyPopupShow: (state, { payload }: { payload: boolean }) => {
      state.copyPopupShow = payload;
      state.triggerCopying = !state.triggerCopying;
    },
    setIsSidebarOpened: (state, { payload }: { payload: boolean }) => {
      state.isSidebarOpened = payload;
      LocalStorage.set(SIDEBAR_CACHE_KEY, payload.toString());
    },
    setSearchProjectText: (state, { payload }: { payload: string }) => {
      state.searchProjectText = payload;
    },
    setSearchProjectArchiveText: (state, { payload }: { payload: string }) => {
      state.searchArchiveProjectText = payload;
    },
    setLayoutWidth: (state, { payload }: { payload: number }) => {
      state.layoutWidth = payload;
    },
  },
});

export const {
  setAlertState,
  dropAlertState,
  setCopyPopupShow,
  setIsSidebarOpened,
  setSearchProjectText,
  setSearchProjectArchiveText,
  setLayoutWidth,
} = uiSlice.actions;

export default uiSlice.reducer;
